import { render } from "./TourBanner.vue?vue&type=template&id=929f8120"
import script from "./TourBanner.vue?vue&type=script&lang=js"
export * from "./TourBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__